module.exports = __webpack_public_path__ + "img/cal-pill.110521c6.png";